<template>
    <div class="fixed bottom-12 left-1/2 -translate-x-1/2">
        <div class="flex gap-3">
            <slot />
        </div>
    </div>
</template>
